/**
 * @file Utility functions for unlimited sandboxes event logic and date validation
 */
import { formatDate } from '@@/bits/date'
import { isAppUsing } from '@@/bits/flip'
import { __ } from '@@/bits/intl'
import { LibraryType } from '@@/enums'
import { Library, User } from '@@/types'

const isPartOfUnlimitedSandboxesEvent = (): boolean => {
  // US Pacific (PDT) → Jun 30, 5:00 AM
  // US Eastern (EDT) → Jun 30, 8:00 AM
  // Singapore (SGT) → Jun 30, 8:00 PM
  return isAppUsing('unlimitedSandboxesV2') && new Date() < new Date(Date.UTC(2026, 5, 30, 12, 0, 0))
}

const UNLIMITED_SANDBOXES_EVENT_END_DATE_STRING = '2026-06-30'

const unlimitedSandboxesEventUtcEndDate = (options: Intl.DateTimeFormatOptions): string => {
  // Always display the event end date as June 30 (UTC), ensuring all users see a consistent date regardless of their local timezone.
  return formatDate(UNLIMITED_SANDBOXES_EVENT_END_DATE_STRING, {
    ...options,
    timeZone: 'UTC',
  })
}

const getUnlimitedSandboxesEventBadgeLabel = ({
  library,
  user,
}: {
  library: Library | Partial<Library> | null
  user: User
}): string | undefined => {
  return isPartOfUnlimitedSandboxesEvent() &&
    (library == null || library.libraryType === LibraryType.Solo) &&
    user.tenant_id === 1 &&
    user.membership_tier !== 'platinum'
    ? __('Unlimited until %{date}', {
        date: unlimitedSandboxesEventUtcEndDate({
          month: 'short',
          day: 'numeric',
        }),
      })
    : undefined
}

export { getUnlimitedSandboxesEventBadgeLabel, isPartOfUnlimitedSandboxesEvent, unlimitedSandboxesEventUtcEndDate }
